import countries from "i18n-iso-countries"
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
import React from "react";
import Recaptcha from "react-google-recaptcha";
import { Container } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { GetRecaptchaKey } from "../../../utils/env";

import * as styles from "../GeneralFormStyles.module.scss";
import commodityData from "../form-data/commodity.json"
import jobData from '../form-data/job-area.json'
import industryData from '../form-data/industry.json'
import Select from 'react-select'

const ContactForm = ({ blok }) => {
  const intl = useIntl();
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const [state, setState] = React.useState({});
  const recaptchaRef = React.createRef();
  const [buttonDisabled, setButtonDisabled] = React.useState(true);
  const [selectedCommodities, setSelectedCommodities] = React.useState([])
  const [commodityOther, setCommodityOther] = React.useState(false)
  const [jobOther, setJobOther] = React.useState(false)
  const [industryOther, setIndustryOther] = React.useState(false)
  const options = []
  const countriesInEnglish = countries.getNames('en', {select: "official"})
  const countryCodesAndNames = intl.locale === 'en' ? countriesInEnglish : countries.getNames(intl.locale, {select: "official"})
  for (const country of Object.keys(countryCodesAndNames)) {
    options.push({ value: country, label: countryCodesAndNames[country]})
    options.sort((a,b) => a.label.localeCompare(b.label))
  }

  const handleChange = e => {
    if (e.target) {
      setState({ ...state, [e.target.name]: e.target.value });
    } else {
      setState({ ...state, [e.name]: e.value})
    }
  };

  const handleCommodityChange = e => {
    const {value} = e.target
    if (selectedCommodities.includes(value)) {
      const commodities = selectedCommodities.filter((commodity) => commodity !== value)
      setSelectedCommodities(commodities)
    } else {
      setSelectedCommodities([...selectedCommodities, value])
    }
  }

  const handleSelectChange = e => {
    setState({ ...state, ["country"]: countriesInEnglish[e.value] })
  }

  const checkOtherSelection = (e, bool, callBack) => {
    if (!bool && e.target.value === "other") {
      callBack(true)
    } else if (bool && e.target.value !== "other") {
      callBack(false)
    }
  }


  const handleSubmitForm = (e) => {
    const formData = {...state, ["commodities"]: [...selectedCommodities].join(", ")}
    const recaptchaValue = recaptchaRef.current.getValue();
    ResolveSubmitForm(e, setErrorMessage, setIsLoading, setShowSuccess, recaptchaValue, formData, intl)
  };
  
  const success_message = blok?.success_message ? resolveRichText(blok.success_message) : null
  return (
    <PanelWrapper blok={blok}>
      <Container>
        {showSuccess ? (
          <div className={styles.success}>
            <br />
            <br />
            <p>
            {success_message ? <div dangerouslySetInnerHTML={success_message}></div> : <FormattedMessage id="component.form.contact_form.success_message" />}
            </p>
          </div> 
        ) : (
          <form
            name="contact"
            data-netlify="true"
            data-netlify-recaptcha="true"
            onSubmit={handleSubmitForm}
            className={styles.formWrapper}
            method="POST"
          >
            <noscript>
        <p>This form won't work with Javascript disabled</p>
      </noscript>
            <input type="hidden" name="form-name" value="contact" />
            <div className={styles.formInput}>
              <label htmlFor="contact_name">
                <FormattedMessage id="component.form.contact_form.name_label" />
                &nbsp;<span className={styles.textGreen}>*</span>
              </label>
              <input
                id="contact_name"
                type="text"
                name="name"
                required
                placeholder={
                  intl.messages["component.form.contact_form.name_placeholder"]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div className={styles.formInput}>
              <label htmlFor="contact_email">
                <FormattedMessage id="component.form.contact_form.email_label" />
                &nbsp;<span className={styles.textGreen}>*</span>
              </label>
              <input
                id="contact_email"
                type="email"
                name="email"
                required
                placeholder={
                  intl.messages["component.form.contact_form.email_placeholder"]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div className={styles.formInput}>
              <label htmlFor="contact_phone">
                <FormattedMessage id="component.form.contact_form.phone_label" />
              </label>
              <input
                id="contact_phone"
                type="tel"
                name="phone"
                placeholder={
                  intl.messages["component.form.contact_form.phone_placeholder"]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div className={styles.formInput}>
              <label htmlFor="contact_company">
                <FormattedMessage id="component.form.contact_form.company_label" />
              </label>
              <input
                id="contact_company"
                type="text"
                name="company"
                placeholder={
                  intl.messages[
                    "component.form.contact_form.company_placeholder"
                  ]
                }
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div className={styles.formInput}>
              <label htmlFor="country_region">
                <FormattedMessage id="component.form.contact_form.country_label" />
                &nbsp;<span className={styles.textGreen}>*</span>
              </label>
              <Select
                id="country_region"
                name="country"
                onChange={handleSelectChange}
                options={options}
                disabled={isLoading}
                placeholder={
                  intl.messages[
                  "component.form.contact_form.country_placeholder"
                  ]
                }
                required
              />
            </div>
            <div  className={styles.formInputCheckbox}>
              <label htmlFor="commodities">
                <FormattedMessage id="component.form.contact_form.commodity_label" />
                &nbsp;<span className={styles.textGreen}>*</span>
              </label>
              <input id="commodities" name="commodities" value={selectedCommodities} hidden/>
              <fieldset>
                {commodityData.map((commodity) => {
                  return (
                    <div>
                      <input 
                        type="checkbox" 
                        value={commodity.value}
                        onChange={handleCommodityChange}
                        required={selectedCommodities.length > 0 || commodityOther ? false : true}
                      />
                      <label className={styles.checkboxLabel}>{intl.messages[commodity.label]}</label>
                    </div>
                  )
                })}
                <div>
                  <input type="checkbox" onChange={() => setCommodityOther(!commodityOther)} />
                  <label className={styles.checkboxLabel} >Other</label>
                </div>
              </fieldset>
              <div 
                style={commodityOther ? {display: "block"} : {display: "none"}} 
              >
                <textarea
                  id="commodity_other_hidden"
                  type="text"
                  name="other_commodities"
                  rows={1}
                  placeholder={
                    intl.messages[
                      "component.form.contact_form.commodity_other_placeholder"
                    ]
                  }
                  required={commodityOther ? true : false}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={styles.formInput}>
              <label htmlFor="job_area">
                <FormattedMessage id="component.form.contact_form.job_area_label" />
              </label>
              <select
                id="job_area"
                name="job"
                onChange={(e) => {
                  checkOtherSelection(e, jobOther, setJobOther)
                  handleChange(e)
                }}
              >
                <option value={null} selected hidden disabled>{
                 intl.messages[
                  "component.form.contact_form.job_area_placeholder"
                  ]
                }</option>
                {jobData.map((job) => {
                  return (
                    <option key={job.id} value={job.value}>{intl.messages[job.label]}</option>
                  )
                })}
              <option value={"other"}>{intl.messages["component.form.contact_form.other_label"]}</option>
              </select>
              <div 
                style={jobOther ? {display: "block"} : {display: "none"}} 
                className={styles.otherText}
              >
                <textarea
                  id="job_other_hidden"
                  rows={1}
                  type="text"
                  name="other_jobs"
                  placeholder={
                    intl.messages[
                      "component.form.contact_form.job_other_placeholder"
                    ]
                  }
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={styles.formInput}>
              <label htmlFor="industry">
                <FormattedMessage id="component.form.contact_form.industry_label" />
              </label>
              <select
                id="industry"
                name="industry"
                onChange={(e) => {
                  checkOtherSelection(e, industryOther, setIndustryOther)
                  handleChange(e)
                }}
              >
                <option value={null} selected hidden disabled>{
                  intl.messages[
                    "component.form.contact_form.industry_placeholder"
                  ]
                }</option>
                {industryData.map((industry) => {
                  return (
                    <option value={industry.value}>{intl.messages[industry.label]}</option>
                  )
                })}
                <option value={"other"}>{intl.messages["component.form.contact_form.other_label"]}</option>
              </select>
              <div 
                style={industryOther ? {display: "block"} : {display: "none"}} 
                className={styles.otherText}
              >
                <textarea
                  id="industry_other_hidden"
                  type="text"
                  rows={1}
                  name="other_industries"
                  placeholder={
                    intl.messages[
                      "component.form.contact_form.industry_other_placeholder"
                    ]
                  }
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={styles.formInput}>
              <label htmlFor="contact_message">
                <FormattedMessage id="component.form.contact_form.message_label" />
              </label>
              <textarea
                id="contact_message"
                rows="5"
                name="message"
                placeholder={
                  intl.messages[
                    "component.form.contact_form.message_placeholder"
                  ]
                }
                onChange={handleChange}
                disabled={isLoading}
              ></textarea>
            </div>
            {errorMessage ? (
              <p className={styles.error}>{errorMessage}</p>
            ) : null}
            <Recaptcha 
              ref={recaptchaRef}
              sitekey={GetRecaptchaKey()}
              size="normal"
              id="recaptcha-google"
              onChange={() => setButtonDisabled(false)}
          />
            <div style={{ textAlign: "center", paddingTop: "40px" }}>
              <button
                type="submit"
                disabled={buttonDisabled}
                className={styles.btnSolidBlue}
              >
                <FormattedMessage id="component.form.contact_form.submit_text" />
              </button>
            </div>
          </form>
        )}
      </Container>
      </PanelWrapper>
  );
};

export default ContactForm;
